module.exports = __webpack_public_path__ + "static/media/4.a6a47449.png";